import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

export default function Renters() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 bg-blue-100 text-[#1E40AF] rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon="FiKey" className="text-4xl" />
        </div>
        <h1 className="text-3xl font-bold text-slate-800 mb-4">Renter's Insurance Coming Soon</h1>
        <p className="text-slate-600 mb-8">
          We're currently building our dedicated renter's insurance experience. In the meantime, we'd still love to help you protect your belongings!
        </p>
        <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 mb-8 text-left">
          <h3 className="font-semibold text-slate-800 mb-2">Why Renter's Insurance?</h3>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="flex gap-2"><SafeIcon icon="FiCheck" className="text-[#10B981] mt-1" /> Covers theft of your personal items</li>
            <li className="flex gap-2"><SafeIcon icon="FiCheck" className="text-[#10B981] mt-1" /> Provides liability protection</li>
            <li className="flex gap-2"><SafeIcon icon="FiCheck" className="text-[#10B981] mt-1" /> Often costs less than $15/month</li>
          </ul>
        </div>
        <div className="flex flex-col gap-4">
          <a href="tel:5624021737" className="bg-[#1E40AF] hover:bg-blue-800 text-white font-semibold py-3 px-6 rounded-xl transition-colors flex items-center justify-center gap-2">
            <SafeIcon icon="FiPhone" /> Call Us Now: (562) 402-1737
          </a>
          <button onClick={() => navigate('/')} className="text-slate-500 hover:text-slate-800 font-medium">
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
}